import { render } from "./topicCheck.vue?vue&type=template&id=b0f3de56&scoped=true"
import script from "./topicCheck.vue?vue&type=script&lang=js"
export * from "./topicCheck.vue?vue&type=script&lang=js"

import "./topicCheck.vue?vue&type=style&index=0&id=b0f3de56&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f3de56"]])

export default __exports__